import { sampleService, type SampleListParams } from '../services/sample.service';

/** バックエンド一覧の limit 上限（sample.controller）に合わせる */
const LIST_CHUNK = 1000;

/**
 * 現在の検索／スコープに一致するサンプル ID を全ページ分取得する。
 * 選択エクスポートの「一致するすべてを選択」用。
 */
export async function fetchMatchingSampleIds(options: {
  total: number;
  search?: string;
  adminViewAll?: boolean;
}): Promise<number[]> {
  const { total, search, adminViewAll } = options;
  if (total <= 0) return [];

  const base: SampleListParams = {
    search: search || undefined,
    adminViewAll: adminViewAll || undefined,
    limit: LIST_CHUNK,
  };

  const ids: number[] = [];
  const pageCount = Math.max(1, Math.ceil(total / LIST_CHUNK));

  for (let page = 1; page <= pageCount; page += 1) {
    const res = await sampleService.list({ ...base, page });
    for (const sample of res.data) {
      ids.push(sample.id);
    }
    if (res.data.length < LIST_CHUNK) break;
  }

  return ids;
}
